import React from 'react';
export function FixedCTABar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] py-3 px-4 md:hidden" data-id="element-46">
      <a href="https://centrocumbre.com/cart/46319925100743:1" className="block w-full bg-brand-orange text-brand-black font-bold text-lg py-3.5 rounded-xl text-center shadow-lg active:scale-[0.98] transition-transform" data-id="element-47">
        Ingresar ahora →
      </a>
    </div>;
}